// fix B-10: guard zero denominators to prevent Infinity results
// Three-phase inductive
export const calcThreePhaseAmperage = (kw: number, v: number, pf: number, eff: number) =>
  (v <= 0 || pf <= 0 || eff <= 0) ? 0 : (kw * 1000) / (v * 1.732 * pf * (eff / 100));
export const calcThreePhaseVoltage = (kw: number, a: number, pf: number, eff: number) =>
  (a <= 0 || pf <= 0 || eff <= 0) ? 0 : (kw * 1000) / (a * 1.732 * pf * (eff / 100));
export const calcThreePhasePower = (a: number, v: number, pf: number, eff: number) =>
  (a * v * 1.732 * pf * (eff / 100)) / 1000;

// Single-phase inductive
export const calcSinglePhaseInductiveAmperage = (kw: number, v: number, pf: number, eff: number) =>
  (v <= 0 || pf <= 0 || eff <= 0) ? 0 : (kw * 1000) / (v * pf * (eff / 100));
export const calcSinglePhaseInductiveVoltage = (kw: number, a: number, pf: number, eff: number) =>
  (a <= 0 || pf <= 0 || eff <= 0) ? 0 : (kw * 1000) / (a * pf * (eff / 100));
export const calcSinglePhaseInductivePower = (a: number, v: number, pf: number, eff: number) =>
  (a * v * pf * (eff / 100)) / 1000;

// Single-phase resistive
export const calcSinglePhaseResistiveAmperage = (kw: number, v: number) => v <= 0 ? 0 : (kw * 1000) / v;
export const calcSinglePhaseResistiveVoltage = (kw: number, a: number) => a <= 0 ? 0 : (kw * 1000) / a;
export const calcSinglePhaseResistivePower = (a: number, v: number) => (a * v) / 1000;
